<template>
    <div>
        <div class="flex justify-between">
            <div class="flex flex-wrap justify-start gap-6 mb-6">
                <div class="h-[100px] border-gray-200 box-border px-5 border-2 rounded flex justify-start items-center gap-1">
                    <p class="box-border inline-block">
                        Tổng sản lượng ({{ dataOrder?.transportation === 'CONTAINER' ? 'cont' : 'xe' }}):
                    </p>
                    <p class="text-3xl break-words text-blue-800 font-bold text-center">
                        {{ $formatters.formatNumber(dataOrder.productivityOrder) }}
                    </p>
                    <edit-productivity
                        :productivity-order="dataOrder.productivityOrder || 0"
                        :allotted="dataOrder.allotted || 0"
                        :order-id="dataOrder._id"
                        @update="updateProductivityOrder" />
                </div>

                <div class="h-[100px] border-gray-200 box-border px-5 border-2 rounded flex justify-start items-center gap-1 relative">
                    <p class="box-border">
                        Phân bổ thành công ({{ dataOrder?.transportation === 'CONTAINER' ? 'cont' : 'xe' }}):
                    </p>
                    <p class="text-3xl break-words text-orange-600 font-bold text-center">
                        {{ $formatters.formatNumber(dataOrder.allotted) }}
                    </p>

                    <div class="absolute right-2 bottom-3 px-5">
                        <p class="box-border text-sm">
                            Chờ điều xe:
                            <span class="text-orange-600">
                                {{ $formatters.formatNumber(dataOrder.notYetDistributionNumber) }}
                            </span>
                        </p>
                    </div>
                </div>

                <div class="h-[100px] border-gray-200 box-border px-5 border-2 rounded flex justify-start items-center gap-1">
                    <p class="box-border">
                        Chờ phân bổ ({{ dataOrder?.transportation === 'CONTAINER' ? 'cont' : 'xe' }}):
                    </p>
                    <p class="text-3xl break-words text-green-800 font-bold text-center">
                        {{ $formatters.formatNumber(dataOrder.waitingForAllocation) }}
                    </p>
                </div>
            </div>

            <!--
              <div class="flex">
              <add-partner
              class="min-w-[180px]"
              :order-id="dataOrder._id"
              :order-code="dataOrder.code"
              @update-allotment="updateAllotment" />

              <hts-form-button
              v-if="checkPermission(layoutPermissions.order_allotment_add)"
              class="min-w-[180px]"
              color="primary"
              :disabled="CDisabledAllotment"
              :outline="false"
              @click="openModelEditAllotment">
              Phân bổ đơn hàng
              </hts-form-button>
              </div>
            -->
        </div>

        <hts-data-table
            ref="dataTables"
            :headers="headers"
            :items="CAllotment || []" />

        <edit-allotment
            ref="editAllotment"
            :order="dataOrder"
            :order-id="dataOrder._id"
            :order-code="dataOrder.code"
            :productivity-order="dataOrder.productivityOrder"
            :waiting-for-allocation="dataOrder.waitingForAllocation"
            :transportation="dataOrder.transportation"
            :merge-container="dataOrder.mergeContainer"
            :head-container="dataOrder.headContainer"
            :positions="dataOrder.positions"
            :charge-name="dataOrder.chargeName"
            :allotted="dataOrder.allotted || 0"
            @updateProductivityOrder="updateProductivityOrder"
            @reload-container-number="reloadContainerNumber"
            @update="(val) => updateAllotment(val)" />
    </div>
</template>
<script setup>
import EditProductivity from '../component/edit-productivity'
import data from '../imports/data'
import EditAllotment from './edit-allotment.vue'
const { $formatters, $event } = useNuxtApp()
const { EOrderStatuses, EAllocationStatus } = data()
const props = defineProps({
  dataOrder: Object
})

const emits = defineEmits(['updateAllotment', 'reload-container-number'])

const dataTables = ref()
const editAllotment = ref()

const { dataOrder } = toRefs(props)

const CAllotment = computed(() => {
  return dataOrder.value?.allotment?.sort((a, b) => a.type.localeCompare(b.type)) || []
})

const openModelEditAllotment = () => {
  if (editAllotment.value) {
    editAllotment.value.open(CAllotment.value)
  }
}

const CDisabledAllotment = computed(() => {
  try {
    if (!dataOrder.value) {
      return false
    }
    if (!dataOrder.value.quote) {
      return true
    }

    if (!dataOrder.value.allotment) {
      return true
    }

    // notquote, not tối ưu ko cho xem bảng phân bổ
    const blackAllocationStatus = [EAllocationStatus.NOT_QUOTE, EAllocationStatus.NOT_QUOTE_AND_OPTIMAL_TIME, EAllocationStatus.NOT_OPTIMAL_TIME]

    if (blackAllocationStatus.includes(dataOrder.value.allocationStatus)) {
      return true
    }

    const status = dataOrder.value.status
    if (status === EOrderStatuses.CANCEL || status === EOrderStatuses.COMPLETE) {
      return true
    }

    return false
  } catch (e) {
    return false
  }
})

const updateAllotment = (val) => {
  dataOrder.value.allotment = val.allotment
  dataOrder.value.waitingForAllocation = val.waitingForAllocation
  dataOrder.value.allotted = val.allotted
  dataOrder.value.notYetDistributionNumber = val.notYetDistributionNumber
  dataOrder.value.charges = val.charges
  dataOrder.value.pricingEstimate = val.pricingEstimate

  if (dataTables.value) {
    dataTables.value.refresh()
  }

  emits('updateAllotment')
}

const updateProductivityOrder = (data) => {
  dataOrder.value.productivityOrder = data.productivityOrder
  dataOrder.value.waitingForAllocation = data.waitingForAllocation
}

const reloadContainerNumber = () => {
  emits('reload-container-number')
}

onMounted(() => listenUpdate())
onUnmounted(() => unListenUpdate())

const listenUpdate = () => {
  if (process.client) {
    $event.listen(`order-${dataOrder.value._id}`, (data) => {
      dataOrder.value.allotment = data.allotment
      refreshAllotment()
    })
  }
}

const refreshAllotment = () => {
  if (dataTables.value) {
    nextTick(() => {
      dataTables.value.refresh()
    })
  }
}

const unListenUpdate = () => {
  if (process.client) {
    $event.unsubscribe(`order-${dataOrder.value._id}`, () => {})
  }
}

const headers = [
  {
    field: 'name',
    headerName: $t('labels.fleetVehicle'),
    minWidth: 150,
    valueGetter: (params) => {
      const name = params.data.name
      return name || ''
    }
  },
  {
    field: 'contact',
    headerName: $t('labels.vendorPriceModule.contact'),
    minWidth: 150,
    valueGetter: (params) => {
      const contact = params.data.contact
      return contact || ''
    }
  },
  {
    field: 'priceBuy',
    headerName: $t('labels.shipingCost'),
    minWidth: 150,
    valueGetter: (params) => {
      const priceBuy = params.data.priceBuy || 0
      const priceOfflineFee = params.data.priceOfflineFee || 0
      return $formatters.formatNumber(priceBuy + priceOfflineFee)
    }
  },
  {
    field: 'productivity',
    headerName: $t('labels.productivityAllotment'),
    headerValueGetter: (params) => {
      const isCont = dataOrder.value.transportation === 'CONTAINER'
      return `${$t('labels.productivityAllotment')} (${isCont ? $t('labels.cont') : $t('labels.vehicle')})`
    },
    minWidth: 150,
    valueGetter: (params) => {
      const productivity = params.data.productivity
      if (!productivity) {
        return ''
      }
      return $formatters.formatNumber(productivity)
    }
  },
  {
    field: 'tripNumber',
    headerName: `${$t('labels.tripNumber')} (${$t('labels.journey')})`,
    minWidth: 150,
    valueGetter: (params) => {
      const tripNumber = params.data.tripNumber
      if (!tripNumber) {
        return ''
      }
      return $formatters.formatNumber(tripNumber)
    }
  },
  {
    field: 'confirmTripNumber',
    headerName: `${$t('labels.confirm')} (${$t('labels.journey')})`,
    minWidth: 150,
    valueGetter: (params) => {
      const confirmTripNumber = params.data.confirmTripNumber || 0
      if (!confirmTripNumber) {
        return ''
      }
      return $formatters.formatNumber(confirmTripNumber)
    }
  },
  {
    field: 'rejectTripNumber',
    headerName: `${$t('labels.reject')} (${$t('labels.journey')})`,
    minWidth: 150,
    valueGetter: (params) => {
      const type = params.data.type

      const rejectTripNumber = params.data.rejectTripNumber || 0

      if (type === 'internal') {
        return rejectTripNumber
      }

      if (!rejectTripNumber) {
        return ''
      }
      return $formatters.formatNumber(rejectTripNumber)
    }
  }
]
</script>
